import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
// import clsx from 'clsx'
import BackToTopCTA from 'components/shared/back-to-top-cta'
// import CategorySideBarSkeleton from 'components/shared/category/sidebar/skeleton'
import { hasLocizeTranslation } from 'lib/utils/locize'
// import Typo from 'constants/typography'
import { customFlagValue } from 'lib/utils/handle-flag/const'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import scrollToContentStickyNavigations from 'components/home/home-page-content/content-sticky-navigations/utility'
import LoadPreviousCta from './load-previous-cta'
import CategoryHeader from '../header'
import styles from './styles.scss'
// import SortAndFilter from '../sort-and-filter/SortAndFilter'

const BrandHeader = dynamic(() => import('components/brand-header'), {
  ssr: false,
})
const MobileSortFilter = dynamic(() => import('../mobile-sort-filter'), {
  ssr: false,
  loading: () => <div style={{ height: '100px' }} />,
})
// const CategorySidebar = dynamic(() => import('../sidebar'), {
//   ssr: false,
//   loading: () => <CategorySideBarSkeleton />,
// })
const CAT_REFINE_STYLE = '%s style'
const CAT_REFINE_STYLE_KEY = 'CAT_REFINE_STYLE'
const CAT_REFINE_STYLES = '%s styles'
const CAT_REFINE_STYLES_KEY = 'CAT_REFINE_STYLES'

class CategoryLayout extends React.Component {
  constructor() {
    super()
    this.state = {
      showBackToTop: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.checkShowBackToTop)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkShowBackToTop)
  }

  shouldShowNewBrandPageDesign = () => {
    const { brandDetails } = this.props
    return brandDetails && customFlagValue({ defaultValue: false }) // TODO: force flag value and will handle with flagsmith later (NewBrandPage-20220602)
  }

  checkShowBackToTop = () => {
    const { showBackToTop } = this.state
    const newVal =
      document.body.scrollTop > 300 || document.documentElement.scrollTop > 300

    if (showBackToTop !== newVal) {
      this.setState({ showBackToTop: newVal })
    }
  }

  callSetPageOne = (resetFilters) => {
    const { setPageOne, isHomepageCategoryPage, selectedTopNavigation } =
      this.props

    if (isHomepageCategoryPage) {
      const isBestSeller =
        selectedTopNavigation?.attributes?.sub_type === 'best-sellers'
      scrollToContentStickyNavigations(isBestSeller, -50)
    } else {
      window.scroll(0, 0)
    }

    setPageOne(resetFilters)
  }

  renderMobileSortFilter() {
    const {
      isSearchPage,
      quickSizes,
      relatedCategories,
      sortFilterOptions,
      t,
      totalProducts,
      refId,
      refType,
    } = this.props

    return (
      <MobileSortFilter
        refId={refId}
        refType={refType}
        isSearchPage={isSearchPage}
        relatedCategories={relatedCategories}
        setPageOne={this.callSetPageOne}
        sortFilterOptions={sortFilterOptions}
        t={t}
        title={this.getDisplayTitle()}
        quickSizes={quickSizes}
        totalLabel={this.getTotalProductWithPostfix(totalProducts)}
      />
    )
  }

  getTotalProductWithPostfix(totalProducts) {
    const { t } = this.props
    const key = totalProducts > 1 ? CAT_REFINE_STYLES_KEY : CAT_REFINE_STYLE_KEY
    const fallback = totalProducts > 1 ? CAT_REFINE_STYLES : CAT_REFINE_STYLE
    const text = hasLocizeTranslation(t, key, fallback)

    return text.replace('%s', totalProducts?.toLocaleString())
  }

  getDisplayTitle() {
    const { categoryBanner, isSearchPage, isPhone, t, title } = this.props
    const hasBanner = !!(
      (isPhone && categoryBanner?.web_mobile) ||
      (!isPhone && categoryBanner?.web)
    )

    if (isSearchPage || (!this.shouldShowNewBrandPageDesign() && hasBanner)) {
      return t(title)
    }

    return t('All Products')
  }

  // renderDesktopTitleBar() {
  //   const { isPhone, isSearchPage, sortFilterOptions, totalProducts } =
  //     this.props

  //   return (
  //     <div className="category-title__wrapper" ref={this.headerSectionEl}>
  //       <div className="category-title__name">
  //         <h1 className={clsx(Typo.h1SEO, 'category-title__header')}>
  //           {this.getDisplayTitle()}
  //         </h1>
  //         {!isPhone && totalProducts > 0 && (
  //           <React.Fragment>
  //             &nbsp;&nbsp;
  //             <span className={clsx(Typo.body2, 'category-title__total')}>
  //               ({this.getTotalProductWithPostfix(totalProducts)})
  //             </span>
  //           </React.Fragment>
  //         )}
  //       </div>
  //       {sortFilterOptions?.sort && (
  //         <SortAndFilter
  //           isSearchPage={isSearchPage}
  //           setPageOne={this.callSetPageOne}
  //           sortOptions={sortFilterOptions.sort}
  //         />
  //       )}
  //     </div>
  //   )
  // }

  renderBody() {
    const { children, onLoadPreviousClicked, t } = this.props
    const { showBackToTop } = this.state

    return (
      <React.Fragment>
        {!!onLoadPreviousClicked && (
          <LoadPreviousCta
            onLoadPreviousClicked={onLoadPreviousClicked}
            t={t}
          />
        )}
        {children}
        <BackToTopCTA showBackToTop={showBackToTop} />
      </React.Fragment>
    )
  }

  // renderCategorySideBar() {
  //   const { isSearchPage, relatedCategories, sortFilterOptions, title } =
  //     this.props

  //   if (!relatedCategories) {
  //     return <CategorySideBarSkeleton />
  //   }

  //   return (
  //     <CategorySidebar
  //       filters={sortFilterOptions}
  //       isSearchPage={isSearchPage}
  //       relatedCategories={relatedCategories}
  //       query={title}
  //       setPageOne={this.callSetPageOne}
  //     />
  //   )
  // }

  renderHeader() {
    const {
      brandDetails,
      categoryBanner,
      categoryId,
      isNewCategoryFiltersAndSort,
      isSearchPage,
      isHomepageCategoryPage,
      title,
    } = this.props

    if (isSearchPage || isHomepageCategoryPage) {
      return null
    }

    if (this.shouldShowNewBrandPageDesign()) {
      return <BrandHeader {...brandDetails} />
    }

    return (
      <CategoryHeader
        categoryBanner={categoryBanner}
        categoryId={categoryId}
        isNewCategoryFiltersAndSort={isNewCategoryFiltersAndSort}
        setPageOne={this.callSetPageOne}
        title={title}
      />
    )
  }

  render() {
    // const { isPhone } = this.props
    const { workwearGrid } = this.props

    return (
      <React.Fragment>
        <style jsx>{styles}</style>
        {this.renderHeader()}
        <React.Fragment>
          {this.renderMobileSortFilter()}
          <div
            className={clsx('category-body__wrapper', {
              'workwear-grid': workwearGrid,
            })}
          >
            {this.renderBody()}
          </div>
        </React.Fragment>
        {/* {isPhone ? (
          <React.Fragment>
            {this.renderMobileSortFilter()}
            {this.renderBody()}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {this.renderCategorySideBar()}
            <div className="category-body__wrapper">
              {this.renderDesktopTitleBar()}
              {this.renderBody()}
            </div>
          </React.Fragment>
        )} */}
      </React.Fragment>
    )
  }
}

CategoryLayout.defaultProps = {
  brandDetails: undefined,
  categoryBanner: null,
  categoryId: null,
  children: null,
  isNewCategoryFiltersAndSort: false,
  isSearchPage: false,
  isHomepageCategoryPage: false,
  onLoadPreviousClicked: null,
  quickSizes: undefined,
  relatedCategories: null,
  title: '',
  selectedTopNavigation: null,
  refId: null,
  refType: 'category',
  workwearGrid: false,
}

CategoryLayout.propTypes = {
  brandDetails: PropTypes.shape({
    brand_name: PropTypes.string.isRequired,
    brand_desc: PropTypes.string.isRequired,
    brand_media: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        type: PropTypes.oneOf(['image', 'video']),
      }),
    ).isRequired,
  }),
  categoryBanner: PropTypes.shape({
    web: PropTypes.string,
    web_mobile: PropTypes.string,
  }),
  categoryId: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isPhone: PropTypes.bool.isRequired,
  isNewCategoryFiltersAndSort: PropTypes.bool,
  isSearchPage: PropTypes.bool,
  isHomepageCategoryPage: PropTypes.bool,
  onLoadPreviousClicked: PropTypes.func,
  quickSizes: PropTypes.arrayOf(PropTypes.string),
  relatedCategories: PropTypes.arrayOf(PropTypes.shape({})),
  setPageOne: PropTypes.func.isRequired,
  sortFilterOptions: PropTypes.shape({
    sort: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  totalProducts: PropTypes.number.isRequired,
  selectedTopNavigation: PropTypes.shape({
    attributes: PropTypes.shape({
      sub_type: PropTypes.string,
    }),
  }),
  refId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  refType: PropTypes.string,
  workwearGrid: PropTypes.bool,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    isHomepageCategoryPage: state.homePage.isHomepageCategoryPage,
    selectedTopNavigation: state.homePage.selectedTopNavigation,
  })),
  withI18next(),
)(CategoryLayout)
